'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { analytics } from '@/adapters/analytics';

export default function AnalyticsProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname?.startsWith('/exp')) return;
    if (isAnalyticsDeclined() || isOptedOut()) return;
    const query = searchParams?.toString();
    const url = query ? `${pathname}?${query}` : pathname;
    analytics.pageView({ url });
  }, [pathname, searchParams]);

  return null;
}

function isOptedOut() {
  if (typeof document === 'undefined') return false;
  return document.cookie.split(';').some((cookie) => cookie.trim().startsWith('ccpa_opt_out=1'));
}

function isAnalyticsDeclined() {
  if (typeof document === 'undefined') return false;
  return document.cookie
    .split(';')
    .some((cookie) => cookie.trim().startsWith('analytics_consent=declined'));
}
